// extracted by mini-css-extract-plugin
export default {"container":"TabletView_container__ZczOj","card":"TabletView_card__amKRH","info-grid":"TabletView_info-grid__SApVp","logo":"TabletView_logo__aKk7N"};